module.exports = __webpack_public_path__ + "static/media/contemporary-glam.86916723.png";